/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-nested-ternary */
import React, { FC, useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import moment from 'moment'
import { FaBuilding, FaEnvelope, FaRegTimesCircle } from 'react-icons/fa'
import { Image } from 'react-bootstrap'
import CompanyImg from '../../../../assets/img/gray_logo_icon.svg'
import CircleCheckboxIcon from '../../../CircleCheckboxIcon'
import { Search as SearchStore } from '../../../../stores/search'
import { removeDuplicates } from '../../../../utils/HelperFunctions'
import BulkLeadActions from '../../Common/BulkLeadActions'

type ColumnID =
  | 'Select'
  | 'Send Date'
  | 'Name'
  | 'Recipient'
  | 'Subject'
  | 'Maneuver'
  | 'Touch'
  | 'Opened Count'
  | 'Replied'
  | 'Rank'

type Order = 'asc' | 'desc'

interface Column {
  id: ColumnID
  label: string
  minWidth?: number
  align?: 'left'
  format?: (value: number) => string
}

const columns: Column[] = [
  { id: 'Select', label: 'SELECT ALL', minWidth: 70, align: 'left' },
  { id: 'Send Date', label: 'EMAIL SENT', minWidth: 70, align: 'left' },
  { id: 'Name', label: 'CONTACT', minWidth: 70, align: 'left' },
  { id: 'Recipient', label: 'EMAIL + COMPANY NAME', minWidth: 120, align: 'left' },
  { id: 'Rank', label: 'RANK', minWidth: 120, align: 'left' },
  { id: 'Subject', label: 'SUBJECT', minWidth: 120, align: 'left' },
  { id: 'Maneuver', label: 'MANEUVER + MISSION', minWidth: 70, align: 'left' },
  { id: 'Touch', label: 'TOUCH', minWidth: 70, align: 'left' },
  { id: 'Opened Count', label: 'OPENED', minWidth: 70, align: 'left' },
  { id: 'Replied', label: 'REPLIED', minWidth: 50, align: 'left' },
]

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}
interface Props extends RouteComponentProps {
  search?: SearchStore
  data: any
  setTypeProp: any
  setCurrentUser: any
  isChartOpened: any
  setselectedLeadsEmails: any
  setOpenActions: any
}

const ReportTable: FC<Props> = props => {
  const {
    search,
    data,
    setTypeProp,
    setCurrentUser,
    isChartOpened,
    setselectedLeadsEmails,
    setOpenActions,
  } = props

  const [selectedItems, setselectedItems] = useState({})
  const [isSelectAll, setisSelectAll] = useState(false)
  const [tableData, settableData] = useState<any>([])
  const [isLoading, setisLoading] = useState(false)

  const useStyles = makeStyles({
    root: {
      width: '100%',
    },
    container: {
      maxHeight: `calc(100vh - ${isChartOpened ? '780' : '350'}px)`,
      minHeight: 200,
    },
    headCell: {
      background: '#59595B',
      color: '#fff',
      padding: '9px 10px',
      lineHeight: '17px',
      borderRight: '1px solid white',
      fontSize: 10,
      '& .icon-container': {
        marginRight: '10px !important',
      },
    },
    tableBodyCell: {
      padding: '9px 10px',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    headSortCell: {
      flexDirection: 'row-reverse',
      color: 'white !important',
      '& svg': {
        color: 'white !important',
      },
    },
  })

  const classes = useStyles()
  const [order, setOrder] = useState<Order>('asc')
  const [orderBy, setOrderBy] = useState('Name')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(50)

  const onCheck = (id): void => {
    const checkedItems = { ...selectedItems }
    if (checkedItems[id]) {
      delete checkedItems[id]
    } else {
      checkedItems[id] = true
    }
    setselectedItems(checkedItems)
  }

  const getSelectedData: any = () => {
    let selectedData = Object.keys(selectedItems)
      ?.map(item => tableData?.find(i => i?.id === item)?.Recipient)
      ?.filter(Boolean)
    selectedData = removeDuplicates(selectedData)
    return selectedData
  }

  useEffect(() => {
    const selectedCount = Object.keys(selectedItems)?.length
    setselectedLeadsEmails(getSelectedData())
    setOpenActions(selectedCount > 1)
  }, [selectedItems])

  const handleChangePage = (event: unknown, newPage: number): void => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  const getManeuver = (str: string): string => {
    const ManeuverMappings = {
      'first touch': 'Rev-Up',
      'follow up': 'Engaged',
      nurture: 'Re-Engage',
    }
    return str ? ManeuverMappings[str.toLowerCase()] : ''
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const createSortHandler = property => event => {
    handleRequestSort(event, property)
  }

  useEffect(() => {
    let dataObj = [...data]
    dataObj.forEach((item, index): void => {
      // eslint-disable-next-line no-param-reassign
      item.id = `${item?.Recipient}/${index}/${item?.['Send Date']}`
    })

    if (order && orderBy) {
      if (rowsPerPage > 0) {
        dataObj = stableSort(dataObj, getComparator(order, orderBy)).slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage,
        )
      }
    }
    settableData(dataObj)
    setCurrentUser(data[0])
  }, [data, order, orderBy, rowsPerPage, page])

  const handleSelectAll = () => {
    // eslint-disable-next-line prefer-const
    let dataObj = {}
    if (!isSelectAll) {
      tableData?.map(item => {
        dataObj[item?.id] = true
      })
    }
    console.log(dataObj)
    setselectedItems(dataObj)
    setisSelectAll(old => !old)
  }

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table" className="report-table">
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                  className={classes.headCell}
                  sortDirection={orderBy === column.id ? order : false}
                >
                  {index === 0 ? (
                    <div
                      className="table-cell"
                      role="button"
                      tabIndex={0}
                      onKeyDown={(): void => {}}
                      onClick={(): void => handleSelectAll()}
                    >
                      <div className="table-item">
                        <CircleCheckboxIcon state={isSelectAll} isWhiteIcon />
                        {column.label}
                      </div>
                    </div>
                  ) : index === 3 ? (
                    <>
                      <TableSortLabel
                        active={orderBy === 'Recipient'}
                        direction={orderBy === 'Recipient' ? order : 'asc'}
                        className={classes.headSortCell}
                        onClick={createSortHandler('Recipient')}
                      >
                        {orderBy === 'Recipient' ? (
                          <span className={classes.visuallyHidden}>
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </span>
                        ) : null}
                        EMAIL
                      </TableSortLabel>
                      <TableSortLabel
                        active={orderBy === 'Company'}
                        direction={orderBy === 'Company' ? order : 'asc'}
                        className={classes.headSortCell}
                        onClick={createSortHandler('Company')}
                      >
                        {orderBy === 'Company' ? (
                          <span className={classes.visuallyHidden}>
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </span>
                        ) : null}
                        COMPANY NAME
                      </TableSortLabel>
                    </>
                  ) : index === 6 ? (
                    <>
                      <TableSortLabel
                        active={orderBy === 'Maneuver'}
                        direction={orderBy === 'Maneuver' ? order : 'asc'}
                        className={classes.headSortCell}
                        onClick={createSortHandler('Maneuver')}
                      >
                        {orderBy === 'Maneuver' ? (
                          <span className={classes.visuallyHidden}>
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </span>
                        ) : null}
                        MANEUVER
                      </TableSortLabel>
                      <TableSortLabel
                        active={orderBy === 'Mission Name'}
                        direction={orderBy === 'Mission Name' ? order : 'asc'}
                        className={classes.headSortCell}
                        onClick={createSortHandler('Mission Name')}
                      >
                        {orderBy === 'Mission Name' ? (
                          <span className={classes.visuallyHidden}>
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </span>
                        ) : null}
                        MISSION
                      </TableSortLabel>
                    </>
                  ) : (
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : 'asc'}
                      onClick={createSortHandler(column.id)}
                      className={classes.headSortCell}
                    >
                      {orderBy === column.id ? (
                        <span className={classes.visuallyHidden}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </span>
                      ) : null}
                      {column.label}
                    </TableSortLabel>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData?.map((row, index) => {
              return (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={row.id}
                  onClick={(): void => setCurrentUser(row)}
                >
                  <TableCell
                    align="center"
                    className={classes.tableBodyCell}
                    onClick={(): void => onCheck(row.id)}
                  >
                    <div className="table-cell">
                      <div className="table-item">
                        <CircleCheckboxIcon state={!!selectedItems[row.id]} />
                        <Image
                          src={CompanyImg}
                          alt="Placeholder"
                          className="avatar"
                          roundedCircle
                        />
                      </div>
                    </div>
                  </TableCell>
                  <TableCell align="center" className={classes.tableBodyCell}>
                    <div className="table-cell">
                      <p className="sub-desc">{moment(row['Send Date']).format('MM.DD.YYYY')}</p>
                    </div>
                  </TableCell>
                  <TableCell align="center" className={classes.tableBodyCell}>
                    <div className="table-cell">
                      <div className="table-item">
                        <p className="sub-desc">{row.Name}</p>
                      </div>
                      <div className="table-item">
                        <p className="sub-desc">{row.Title}</p>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell align="center" className={classes.tableBodyCell}>
                    <div className="table-cell">
                      <div className="table-item">
                        <FaEnvelope className="table-item-icon" />
                        <a href={`mailto:${row.Recipient}`} className="sub-desc">
                          {row.Recipient}
                        </a>
                      </div>
                      <div className="table-item">
                        <FaBuilding className="table-item-icon" />
                        <a
                          className="sub-desc"
                          target="_blank"
                          href={`https://${row.Recipient?.substring(
                            row.Recipient.lastIndexOf('@') + 1,
                          )}`}
                          rel="noopener noreferrer"
                        >
                          {row.Company}
                        </a>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell align="center" className={classes.tableBodyCell}>
                    <div className="table-cell">
                      <p className="sub-desc">{row.Rank ?? '-'}</p>
                    </div>
                  </TableCell>
                  <TableCell align="center" className={classes.tableBodyCell}>
                    <div className="table-cell">
                      <p className="sub-desc">{row.Subject}</p>
                    </div>
                  </TableCell>
                  <TableCell align="center" className={classes.tableBodyCell}>
                    <div className="table-cell">
                      <p className="sub-desc">{getManeuver(row.Maneuver)}</p>
                      <p className="sub-desc">{row?.['Mission Name']}</p>
                    </div>
                  </TableCell>
                  <TableCell align="center" className={classes.tableBodyCell}>
                    <div className="table-cell">
                      <p className="sub-desc">{row.Touch}</p>
                    </div>
                  </TableCell>
                  <TableCell align="center" className={classes.tableBodyCell}>
                    <div className="table-cell">
                      <p className="sub-desc">{row['Opened Count']}</p>
                    </div>
                  </TableCell>
                  <TableCell align="center" className={classes.tableBodyCell}>
                    <div className="table-cell">
                      <div className="table-item">
                        {JSON.stringify(row.Replied) === 'true' ? (
                          <CircleCheckboxIcon state />
                        ) : (
                          <FaRegTimesCircle className="red-icon" />
                        )}
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[20, 50]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        onPageChange={handleChangePage}
      />
    </Paper>
  )
}
export default inject('prospects', 'search')(withRouter(observer(ReportTable)))
